import { Button as _Button } from "@mui/material";
import { Colors } from "../constants/colors";

type ButtonProps = {
  value: string;
  gradient?: boolean;
  fontSize?: number;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
};

const Button = ({ value, onClick, fontSize = 17, type }: ButtonProps) => {
  return (
    <_Button
      onClick={onClick}
      style={{
        background: Colors.primary,
        fontWeight: 300,
        fontSize,
        width: "100%",
        textTransform: "capitalize",
      }}
      type={type || "button"}
      variant="contained"
    >
      {value}
    </_Button>
  );
};

export default Button;
